import { Injectable } from '@angular/core';
import { MessageService, HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let priceListServicesUrl = CONFIG.baseUrls.priceListServices;
export interface PriceListService {
    code?: number;
    serviceCode?: number;
    priceListCode?: number;
    price?: number;
    naphiesCode?: string;
    naphiesDesc?: string;
    nphiesTerminology ?: number;
    alternativeCode?: string;
    alternativeNameEn?: string;
    alternativeNameAr?: string;
    inOutType?: number;
    status?: number;
    listed?: number;
    priceFlag?: boolean;
    dataStatus?: number;
    fixedConsumerValue?: number;
    checked ?:boolean;
    alternativeDesc ?: string

}

export interface PriceListSearchObj {
    firstLevelServiceCode?: number;
    secondLevelServiceCode?: number;
    serviceCode?: number;
    priceListCode?: number;
    inOutType?:number;
    priceFlag?:number;
    companyCode?:number;
    checked ?:boolean;
}



@Injectable()
export class PriceListServiceService {
    constructor(
        private httpGeneralService: HttpGeneralService
    ) { }

    getPriceListServices(priceListSearchObj : PriceListSearchObj) {
        return this.httpGeneralService.add(priceListSearchObj,`${priceListServicesUrl}/getPriceListData`);

    }

    getServicePriceLists(serviceCode: number, inOuType: number) {
        return this.httpGeneralService.getWith(`${priceListServicesUrl}/${serviceCode}/${inOuType}`);
    }
    downloadExcelSheet(priceListCode: number,responseType:string) {
        return this.httpGeneralService.getFileByPost(priceListCode, `${priceListServicesUrl}/ExportDataToExcel`,responseType);
      }
      downloadNotPricedExcelSheet(priceListCode: number,responseType:string) {
        return this.httpGeneralService.getFileByPost(priceListCode, `${priceListServicesUrl}/ExportDataNotPricedToExcel`,responseType);
      }

      downloadAllExcelSheet(priceListCode: number,responseType:string) {
        return this.httpGeneralService.getFileByPost(priceListCode,  `${priceListServicesUrl}/ExportDataAllToExcel`,responseType);
      }
    addPriceListServices(priceListService: PriceListService[]) {
        return this.httpGeneralService.add<PriceListService[]>(priceListService, priceListServicesUrl);
    }

    mappingPriceListServices(priceListService: PriceListService[]) {
        return this.httpGeneralService.add<PriceListService[]>(priceListService, `${priceListServicesUrl}/MappingPriceListService`);
    }
}
